import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {DomSanitizer} from '@angular/platform-browser';
import {SearchSlimData} from '../search-slim/search-slim.component';
import {ModalPlanningHqHelpComponent} from '../modals/modal-planning-hq-help/modal-planning-hq-help.component';
import {ModalPlanningHqWarningComponent} from '../modals/modal-planning-hq-warning/modal-planning-hq-warning.component';
import {ModalDealerEditComponent} from '../modals/modal-dealer-edit/modal-dealer-edit.component';
import {ExcTab} from 'exc-tab';
import {DealerDetailsComponent} from '../dealer-details/dealer-details.component';
import {ModalPlanningHqApprovalComponent} from '../modals/modal-planning-hq-approval/modal-planning-hq-approval.component';

@Component({
  selector: 'app-planning-hq',
  templateUrl: './planning-hq.component.html',
  styles: []
})
export class PlanningHqComponent extends ExcTranslation implements OnInit {

  @ViewChild('contextMenu') contextMenu;
  @ViewChild('trashMenu') trashMenu;
  @ViewChild('acceptWaitPanel') acceptWaitPanel;
  mandantID = null;
  trashMenuShown = false;
  year = new Date().getFullYear();
  currentYear = new Date().getFullYear();
  currentMonth = new Date().getMonth() + 1;
  editMode = false;
  data: any[] = [];
  newAudits: any[] = [];
  movedAudits: any[] = [];
  deletedAudits: any[] = [];
  cancelledAudits: any[] = [];
  newAuditsProcessed = 0;
  movedAuditsProcessed = 0;
  deletedAuditsProcessed = 0;
  cancelledAuditsProcessed = 0;
  applyInProgress = false;
  pagingAactualPage = 1;
  pagingOldOffset;
  seletedAudits: any[] = [];
  dragged: {} = null;
  dataSort = {field: 'DealerName', order: 'asc'};
  lastDragCol: string = null;
  lastDragElement: any = null;
  startDragElement: any = null;
  startDragCol: string = null;
  toDeleteElement: any = null;
  toDeleteCol: string = null;
  paintMode = 'SC';
  menuCol: string = null;
  paging: any;
  pagingInstace: any;
  isLoading = false;
  paginator: any[];
  searchFields = {};
  level = 1;
  colMonthMatch = {
    Jan: 1,
    Feb: 2,
    Mar: 3,
    Apr: 4,
    May: 5,
    Jun: 6,
    Jul: 7,
    Aug: 8,
    Sep: 9,
    Oct: 10,
    Nov: 11,
    Dec: 12
  };
  sum = {
    Sum01: 0,
    Sum02: 0,
    Sum03: 0,
    Sum04: 0,
    Sum05: 0,
    Sum06: 0,
    Sum07: 0,
    Sum08: 0,
    Sum09: 0,
    Sum10: 0,
    Sum11: 0,
    Sum12: 0,
    Sum13: 0,
    Sum14: 0,
    Sum15: 0,
    Sum16: 0,
    Sum17: 0,
    Sum18: 0
  };
  colorFC = {
    CANCELLED: 'rgba(250, 169, 51, 0.9)',
    DONE: 'rgba(3, 181, 56, 0.9)',
    INPROG: 'rgba(88, 200, 224, 0.9)',
    EXPIRED: 'rgba(250, 169, 51, 0.9)',
    REJECTED: 'rgba(201, 48, 44, 0.9)',
    PLANNED: 'rgba(32, 83, 148, 0.9)',
    SELECTED: 'rgba(72, 31, 147, 0.9)',
    MOVETO: 'rgba(156, 255, 56, 0.9)',
    MOVEFROM: 'rgba(255, 56, 76, 0.9)',
    PLANNEDMOV: 'rgba(28,228,228,0.9)'
  };
  colorSC = {
    CANCELLED: 'rgba(250, 169, 51, 0.5)',
    DONE: 'rgba(3, 181, 56, 0.5)',
    INPROG: 'rgba(88, 200, 224, 0.5)',
    EXPIRED: 'rgba(250, 169, 51, 0.5)',
    REJECTED: 'rgba(201, 48, 44, 0.5)',
    PLANNED: 'rgba(32, 83, 148, 0.5)',
    SELECTED: 'rgba(72, 31, 147, 0.5)',
    MOVETO: 'rgba(156, 255, 56, 0.5)',
    MOVEFROM: 'rgba(255, 56, 76, 0.5)',
    PLANNEDMOV: 'rgba(28,228,228,0.5)'
  };
  levelIcons = {
    1: 'fa-user',
    2: 'fa-user-tie',
    3: 'fa-usere',
  };
  constructor(private excRest: ExcRestService, private cdr: ChangeDetectorRef, private sani: DomSanitizer) {
    super();
  }
  editDealer(x) {
    const _self = this;
    ExcCoreModule.showModal(ModalDealerEditComponent, null, 'm-alt', x, true).subscribe( r => {
      if (r && r.proceed === true) {
        r.dealer['DealerUPT'] = x['DealerUPT'];
        const url = _self.excRest.computeUrl('DealerU', {DealerID: x.DealerID});
        _self.excRest.post(url, r.dealer, {}).subscribe(ret => {
          Object.assign(x, ret.data.Header);
        });
      }
    });
  }
  setLevel(lvl) {
    if (this.applyInProgress === true) {
      return;
    }
    if (this.movedAudits.length > 0 || this.newAudits.length > 0
        || this.cancelledAudits.length > 0 || this.deletedAudits.length > 0) {
      ExcCoreModule.showModal(ModalPlanningHqWarningComponent, null, 's', { movedAudits: this.movedAudits.length, newAudits: this.newAudits.length, deletedAudits: this.deletedAudits.length, cancelledAudits: this.cancelledAudits.length }, false).subscribe(ret => {
        if (ret && ret.proceed === true) {
          this.level = lvl;
          this.newAudits = [];
          this.movedAudits = [];
          this.deletedAudits = [];
          this.cancelledAudits = [];
          if (lvl === 2) {
            delete this.searchFields['DealerLevel1'];
          }
          if (lvl === 3) {
            delete this.searchFields['DealerLevel2'];
          }
          this.reload(1, null);
        }
      });
    } else {
      this.level = lvl;
      if (lvl === 2) {
        delete this.searchFields['DealerLevel1'];
      }
      if (lvl === 3) {
        delete this.searchFields['DealerLevel2'];
      }
      this.reload(1, null);
    }
  }

  getTooltip(x, col) {
      let tt = '';
      for (const a of this.data) {
        if (a.DealerID === x.DealerID) {
          if (a[col + 'FCStatus' ] !== null) {
            tt = 'Floorcheck, ' + this.getRessource('STATE_' + a[col + 'FCStatus']);
          }
          if (a[col + 'SCStatus' ] !== null) {
            if (tt.length > 0) {
              tt = tt + '\r\n';
            }
            tt = 'Selfcheck, ' + this.getRessource('STATE_' + a[col + 'SCStatus']);
          }
          break;
        }
      }

    return tt;
  }
  getPrevAuditStyle(state) {
    let col = '#fff';
    if (state !== null) {
      col = this.colorFC[state];
    }
    return {
      backgroundColor: col,
      padding: '0.3rem',
      margin: '0.15rem',
      borderRadius: '4px'

    };
  }
  getMenuheader() {
    let txt = '';
    switch (this.menuCol) {
      case 'Jan': txt = '01'; break;
      case 'Feb': txt = '02'; break;
      case 'Mar': txt = '03'; break;
      case 'Apr': txt = '04'; break;
      case 'May': txt = '05'; break;
      case 'Jun': txt = '06'; break;
      case 'Jul': txt = '07'; break;
      case 'Aug': txt = '08'; break;
      case 'Sep': txt = '09'; break;
      case 'Oct': txt = '10'; break;
      case 'Nov': txt = '11'; break;
      case 'Dec': txt = '12'; break;
    }
    return txt + '/' + this.year;
  }
  getMenubodytext() {
    let cnt = 0;
    for (const x of this.newAudits) {
      if (x['Col'] === this.menuCol) {
        cnt = cnt + 1;
      }
    }
    if (cnt === 0) {
      return 'Keine Änderungen vorgenommen';
    } else if (cnt === 1) {
      return 'Ein neues Audit';
    } else if (cnt > 1) {
      return cnt + ' neue Audits';
    }
  }
  getMonthIconClass(pref, x, col) {
    let clr = '';

    const scLevel = x[pref + col + 'SCLevel'];
    const fcLevel = x[pref + col + 'FCLevel'];
    if (scLevel !== null ) {
      clr = this.levelIcons[scLevel];
    } else {
    }
    if (fcLevel !== null ) {
      clr = this.levelIcons[fcLevel];
    }
    return clr;
  }
  getMonthStyle(isPrimary, pref, x, col) {
    let clr = isPrimary ? '#fff' : '#ddd';
    const scstatus = x[pref + col + 'SCStatus'];
    const fcstatus = x[pref + col + 'FCStatus'];
    if (scstatus !== null ) {
      clr = this.colorSC[scstatus];
    }
    if (fcstatus !== null ) {
      clr = this.colorFC[fcstatus];
    }
    let cursor = 'default';
    if (this.editMode === true) {
      if (this.year < this.currentYear) {
        cursor = 'not-allowed';
      } else if (this.year === this.currentYear && this.colMonthMatch[col] <= this.currentMonth) {
          cursor = 'not-allowed';
      } else {
        if (fcstatus === 'PLANNED' || scstatus === 'PLANNED') {
          if (this.paintMode === 'SC' && scstatus === 'PLANNED') {
            cursor = 'move';
          } else if (this.paintMode === 'FC' && fcstatus === 'PLANNED') {
            cursor = 'move';
          } else {
            cursor = 'not-allowed';
          }
        } else if (fcstatus === 'DONE' || scstatus === 'DONE') {
          cursor = 'not-allowed';
        } else if (fcstatus === 'EXPIRED' || scstatus === 'EXPIRED') {
          cursor = 'not-allowed';
        } else if (fcstatus === 'REJECTED' || scstatus === 'REJECTED') {
          cursor = 'not-allowed';
        } else if (fcstatus === 'CANCELLED' || scstatus === 'CANCELLED') {
          cursor = 'not-allowed';
        } else {
          cursor = 'url(\'assets/scss/paint-brush-solid.svg\') 5 18, crosshair';
        }
      }
    }

    const padding = '0.5rem';
    // let padding = '';
    // if (fcstatus === null && scstatus === null) {
    //   padding = '0.5rem';
    // } else {
    //   if (scstatus !== 'SELECTED' || scstatus !== 'SELECTED') {
    //     padding = '';
    //   } else {
    //     padding = '0.5rem';
    //   }
    // }

    return {
      cursor: cursor,
      backgroundColor: clr,
      userSelect: 'none'
      , paddingRight: padding
      , paddingBottom: padding

    };
  }

  isDragable(x, col) {
    let isDrag = false;
    if (this.editMode === true) {
      if (this.year < this.currentYear) {
        return false;
      }
      if (this.year === this.currentYear) {
        if (this.colMonthMatch[col] <= this.currentMonth) {
          return false;
        }
      }
      isDrag = x['CurrentYear' + col + this.paintMode + 'Status'] === 'PLANNED';
    }
    return isDrag;
  }
  dragStart(x, col, event) {
    if (this.isDragable(x, col)) {
      this.dragged = {obj: x, col: col, evt: event};
      event.dataTransfer.effectAllowed = 'move';
      this.startDragCol = col;
      this.startDragElement = event.srcElement;
    } else {
      event.preventDefault();
    }
  }
  dragEnter(x, col, event) {
    if (x.DealerID === this.dragged['obj'].DealerID && (this.year < this.currentYear || (this.year === this.currentYear && this.colMonthMatch[col] > this.currentMonth))) {
      if (x['CurrentYear' + col + 'FCStatus'] === null && x['CurrentYear' + col + 'SCStatus'] === null) {
        event.srcElement.style.backgroundColor = 'rgba(56, 255, 235, 0.3)';
        this.lastDragCol = col;
        this.lastDragElement = event.srcElement;
      } else {
        this.lastDragCol = null;
        this.lastDragElement = null;
      }
    } else {
        this.lastDragCol = null;
        this.lastDragElement = null;
    }
    event.preventDefault();
  }
  dragLeave(x, col, event) {
    if (x.DealerID === this.dragged['obj'].DealerID) {
      if (x['CurrentYear' + col + 'FCStatus'] === null && x['CurrentYear' + col + 'SCStatus'] === null) {
        event.srcElement.style.backgroundColor = '#ffffff';
      }
    }
  }
  dragEnd(x, col, event) {
    if (x.DealerID === this.dragged['obj'].DealerID && this.lastDragCol !== null && (this.year < this.currentYear || (this.year === this.currentYear && this.colMonthMatch[col] > this.currentMonth))) {
      if (x['CurrentYear' + this.lastDragCol + 'FCStatus'] === null && x['CurrentYear' + this.lastDragCol + 'SCStatus'] === null) {

        x['CurrentYear' + this.lastDragCol + this.paintMode + 'Status'] = 'MOVETO';
        this.dragged['obj']['CurrentYear' + this.startDragCol + this.paintMode + 'Status'] = 'MOVEFROM';
        this.lastDragElement.style.backgroundColor = this['color' + this.paintMode]['MOVETO'];
        this.startDragElement.style.backgroundColor = this['color' + this.paintMode]['MOVEFROM'];
        this.movedAudits.push({DealerID: x.DealerID, Mode: this.editMode, From: this.startDragCol, To: this.lastDragCol, AuditID:  this.dragged['obj']['CurrentYear' + this.startDragCol + this.paintMode]});
      }
    }
    this.lastDragCol = null;
    this.lastDragElement = null;
    this.startDragElement = null;
    this.startDragCol = null;
    event.preventDefault();
  }
  dragOver(x, col, event) {
    event.preventDefault();
  }
  showTrashMenu(event) {
    this.toDeleteElement = this.startDragElement;
    this.toDeleteCol = this.startDragCol;
    this.trashMenu.show(event);
  }

  trashActionDelete() {
    this.trashMenuShown = false;
    this.trashMenu.hide();
    this.toDeleteElement.style.backgroundColor  = '#ffffff';
    this.deletedAudits.push({DealerID: this.dragged['obj']['DealerID'], Mode: this.paintMode, Col: this.toDeleteCol, AuditID:  this.dragged['obj']['CurrentYear' + this.toDeleteCol + this.paintMode]});
    this.dragged['obj']['CurrentYear' + this.toDeleteCol + this.paintMode + 'Status'] = null;
    this.toDeleteCol = null;
    this.toDeleteElement = null;
  }
  trashActionCancel() {
    this.trashMenuShown = false;
    this.trashMenu.hide();
    this.toDeleteElement.style.backgroundColor  = this['color' + this.paintMode]['CANCELLED'];
    this.cancelledAudits.push({DealerID: this.dragged['obj']['DealerID'], Mode: this.paintMode, Col: this.toDeleteCol, AuditID:  this.dragged['obj']['CurrentYear' + this.toDeleteCol + this.paintMode]});
    this.dragged['obj']['CurrentYear' + this.toDeleteCol + this.paintMode + 'Status'] = 'CANCELLED';
    this.toDeleteCol = null;
    this.toDeleteElement = null;
  }
  showMonthContext(col, event) {
    // if (this.editMode === true) {
      this.menuCol = col;
      this.contextMenu.show(event);
    // }
  }

  handleMouseClick(x, col, event) {
    if (this.editMode === true && event.buttons === 1 ) {
      if (((x['CurrentYear' + col + 'SCStatus'] !== null && x['CurrentYear' + col + 'SCStatus'] !== 'SELECTED') || (x['CurrentYear' + col + 'FCStatus'] !== null && x['CurrentYear' + col + 'FCStatus'] !== 'SELECTED'))  && (this.year < this.currentYear || (this.year === this.currentYear && this.colMonthMatch[col] > this.currentMonth))) {
        return;
      }
      if (this.year < this.currentYear) {
        return;
      }
      if (this.year === this.currentYear) {
        if (this.currentMonth[col] <= this.currentMonth) {
          return;
        }
      }

      const fcSet = x['CurrentYear' + col + 'FCStatus'] !== null;
      const scSet = x['CurrentYear' + col + 'SCStatus'] !== null;

      if (this.paintMode === 'SC') {
        if (fcSet) {
          return;
        }
        if (scSet) {
          x['CurrentYear' + col + 'SCStatus'] = null;
          event.srcElement.style['backgroundColor'] = '#FFFFFF';
          this.newAudits = this.newAudits.filter((a) => {
            return !(a.DealerID === x.DealerID && a.Mode === this.paintMode && a.Col === col);
          });
        } else {
          x['CurrentYear' + col + 'SCStatus'] = 'SELECTED';
          event.srcElement.style['backgroundColor'] = this.colorSC.SELECTED;
          this.newAudits.push({DealerID: x.DealerID, Mode: this.paintMode, Col: col });
        }
      } else if (this.paintMode === 'FC') {
        if (scSet) {
          return;
        }
        if (fcSet) {
          x['CurrentYear' + col + 'FCStatus'] = null;
          event.srcElement.style['backgroundColor'] = '#FFFFFF';
          this.newAudits = this.newAudits.filter((a) => {
            return !(a.DealerID === x.DealerID && a.Mode === this.paintMode && a.Col === col);
          });
        } else {
          x['CurrentYear' + col + 'FCStatus'] = 'SELECTED';
          event.srcElement.style['backgroundColor'] = this.colorFC.SELECTED;
          this.newAudits.push({DealerID: x.DealerID, Mode: this.paintMode, Col: col });
        }
      }
    }
  }

  handleMouseEnter(x, col, event) {
    if (this.editMode === true && event.buttons === 1 ) {
      if (((x['CurrentYear' + col + 'SCStatus'] !== null && x['CurrentYear' + col + 'SCStatus'] !== 'SELECTED') ||
           (x['CurrentYear' + col + 'FCStatus'] !== null && x['CurrentYear' + col + 'FCStatus'] !== 'SELECTED'))) {
        return;
      }
      if ((this.year < this.currentYear || (this.year === this.currentYear && this.colMonthMatch[col] <= this.currentMonth))) {
        return;
      }

      const fcSet = x['CurrentYear' + col + 'FCStatus'] !== null;
      const scSet = x['CurrentYear' + col + 'SCStatus'] !== null;

      if (this.paintMode === 'SC') {
        if (fcSet) {
          return;
        }
        if (scSet) {
          x['CurrentYear' + col + 'SCStatus'] = null;
          event.srcElement.style['backgroundColor'] = '#FFFFFF';
          this.newAudits = this.newAudits.filter((a) => {
            return !(a.DealerID === x.DealerID && a.Mode === this.paintMode && a.Col === col);
          });
        } else {
          x['CurrentYear' + col + 'SCStatus'] = 'SELECTED';
          event.srcElement.style['backgroundColor'] = this.colorSC.SELECTED;
          this.newAudits.push({DealerID: x.DealerID, Mode: this.paintMode, Col: col, Lvl: this.level });
        }
      } else if (this.paintMode === 'FC') {
        if (scSet) {
          return;
        }
        if (fcSet) {
          x['CurrentYear' + col + 'FCStatus'] = null;
          event.srcElement.style['backgroundColor'] = '#FFFFFF';
          this.newAudits = this.newAudits.filter((a) => {
            return !(a.DealerID === x.DealerID && a.Mode === this.paintMode && a.Col === col);
          });
        } else {
          x['CurrentYear' + col + 'FCStatus'] = 'SELECTED';
          event.srcElement.style['backgroundColor'] = this.colorFC.SELECTED;
          this.newAudits.push({DealerID: x.DealerID, Mode: this.paintMode, Col: col, Lvl: this.level});
        }
      }
    }
  }
  handleMouseUp(event) {
    // if (event.buttons === 1) {
    //   alert(this.newAudits.length + ' to plan');
    // }
  }

  getSortClass(f) {
    if (this.dataSort.field === f) {
      if (this.dataSort.order === 'asc') {
        return 'fa-sort-up';
      } else {
        return 'fa-sort-down';
      }
    } else {
      return 'fa-sort';
    }
  }
  setSort (f) {
    if (this.dataSort.field === f) {
      if (this.dataSort.order === 'asc') {
        this.dataSort.order = 'desc';
      } else {
        this.dataSort.order = 'asc';
      }
    } else {
      this.dataSort.field = f;
      this.dataSort.order = 'asc';
    }
    this.reload(1, null);
  }
  searchChanged(v: SearchSlimData) {
    if (v.value === null || v.value === '') {
      delete this.searchFields[v.field];
    } else {
      this.searchFields[v.field] = v.value;
    }
    this.reload(1, null);
  }
  showHelp() {
    ExcCoreModule.showModal(ModalPlanningHqHelpComponent, null, 'l', null,  true).subscribe(ret => {});
  }
  initialLoad() {
    if (this.applyInProgress === true) {
      return;
    }
    const _self = this;
    const metainfo = {
      dataFilter: {},
      dataSort: {},
      dataPaging: {pageNo: 1}
    };
    metainfo.dataSort[this.dataSort.field] = this.dataSort.order;
    this.isLoading = true;
    _self.excRest.get(_self.excRest.computeUrl('PlanningHQR_Summary', {AuditYear: _self.year, level: _self.level}), {MetaInfo: metainfo}).subscribe(ret => {
      _self.data = ret.data.Planning;
      _self.sum = ret.data.Summary;
      _self.mandantID = ret.data.Summary.MandantID;
      _self.paging = ret.paging.Planning ;
      _self.paintMode = ret.data.Summary['DefaultEditMode'];
      this.isLoading = false;
    });
  }
  exportData() {
    const url = this.excRest.computeUrl('PlanningHQExport', {AuditYear: this.year});
    window.location.href = url;
  }
  monthExport()  {
    let txt = 0
    switch (this.menuCol) {
      case 'Jan': txt = 1; break;
      case 'Feb': txt = 2; break;
      case 'Mar': txt = 3; break;
      case 'Apr': txt = 4; break;
      case 'May': txt = 5; break;
      case 'Jun': txt = 6; break;
      case 'Jul': txt = 7; break;
      case 'Aug': txt = 8; break;
      case 'Sep': txt = 9; break;
      case 'Oct': txt = 10; break;
      case 'Nov': txt = 11; break;
      case 'Dec': txt = 12; break;
    }
    const url = this.excRest.computeUrl('PlanningHQExportMonth', {AuditYear: this.year, AuditMonth: txt});
    window.location.href = url;
  }
  monthApproval()  {
    let txt = 0;
    switch (this.menuCol) {
      case 'Jan': txt = 1; break;
      case 'Feb': txt = 2; break;
      case 'Mar': txt = 3; break;
      case 'Apr': txt = 4; break;
      case 'May': txt = 5; break;
      case 'Jun': txt = 6; break;
      case 'Jul': txt = 7; break;
      case 'Aug': txt = 8; break;
      case 'Sep': txt = 9; break;
      case 'Oct': txt = 10; break;
      case 'Nov': txt = 11; break;
      case 'Dec': txt = 12; break;
    }
    const _self = this;
    const url = this.excRest.computeUrl('PlanningHQMonthApproval', {AuditYear: this.year, AuditMonth: txt});
    this.excRest.get(url, {}).subscribe(ret => {
      ExcCoreModule.showModal(ModalPlanningHqApprovalComponent, null, 's', ret.data[0], false, null).subscribe();
    });
    this.contextMenu.hide();
  }
  showDealerDetails(x) {
    new ExcTab(x.DealerName, DealerDetailsComponent, x, x.DealerID, {
      Unique: true, ReloadParent: function () {
      }
    }, true).Open();
  }
  applyChanges(e) {
    if (this.newAudits.length === 0 && this.movedAudits.length === 0 && this.cancelledAudits.length === 0 && this.deletedAudits.length === 0) {
      return;
    }
    this.newAuditsProcessed = 0;
    this.movedAuditsProcessed = 0;
    this.deletedAuditsProcessed = 0;
    this.cancelledAuditsProcessed = 0;
    this.applyInProgress = true;
    this.acceptWaitPanel.show(e);
    this.processNextNewAudit();
    this.processNextMovedAudit();
    this.processNextDeletedAudit();
    this.processNextCancelledAudit();
  }

  processNextNewAudit() {
    const _self = this;
    if (_self.newAudits.length === 0 || _self.newAuditsProcessed  === _self.newAudits.length) {
      return;
    }
    const a = _self.newAudits[_self.newAuditsProcessed];
    const o = {
      DealerID: a.DealerID,
      AuditMonth: _self.colMonthMatch[a.Col],
      AuditLevel: _self.level,
      Mode: a.Mode.toUpperCase()

    };
    const url = _self.excRest.computeUrl('PlanningHQAuditC', {AuditYear: _self.year});
    _self.excRest._putInternal(url, o , {} , true).subscribe(ret => {
      if (ret && ret.rtval === 1000) {
        _self.newAuditsProcessed = _self.newAuditsProcessed + 1;
      }
      _self.checkProgress();
      _self.processNextNewAudit();
    });
  }

  processNextMovedAudit() {
    const _self = this;
    if (_self.movedAudits.length === 0 || _self.movedAuditsProcessed  === _self.movedAudits.length) {
      return;
    }
    const a = _self.movedAudits[_self.movedAuditsProcessed];
    const o = {
      AuditMonth: _self.colMonthMatch[a.To]
    };
    const url = _self.excRest.computeUrl('PlanningHQAuditU_Move', {AuditYear: _self.year, AuditID: a.AuditID});
    _self.excRest._postInternal(url, o , {}, true ).subscribe(ret => {
      if (ret && ret.rtval === 1000) {
        _self.movedAuditsProcessed = _self.movedAuditsProcessed + 1;
      }
      _self.checkProgress();
      _self.processNextMovedAudit();
    });
  }

  processNextCancelledAudit() {
    const _self = this;
    if (_self.cancelledAudits.length === 0 || _self.cancelledAuditsProcessed  === _self.cancelledAudits.length) {
      return;
    }
    const a = _self.cancelledAudits[_self.cancelledAuditsProcessed];
    const url = _self.excRest.computeUrl('PlanningHQAuditU_Cancel', {AuditYear: _self.year, AuditID: a.AuditID});
    _self.excRest._postInternal(url, {} , {}, true ).subscribe(ret => {
      if (ret && ret.rtval === 1000) {
        _self.cancelledAuditsProcessed = _self.cancelledAuditsProcessed + 1;
      }
      _self.checkProgress();
      _self.processNextCancelledAudit();
    });
  }

  processNextDeletedAudit() {
    const _self = this;
    if (_self.deletedAudits.length === 0 || _self.deletedAuditsProcessed  === _self.deletedAudits.length) {
      return;
    }
    const a = _self.deletedAudits[_self.deletedAuditsProcessed];
    const url = _self.excRest.computeUrl('PlanningHQAuditD', {AuditYear: _self.year, AuditID: a.AuditID});
    _self.excRest._deleteInternal(url, {} , {} , true).subscribe(ret => {
      if (ret && ret.rtval === 1000) {
        _self.deletedAuditsProcessed = _self.deletedAuditsProcessed + 1;
      }
      _self.checkProgress();
      _self.processNextDeletedAudit();
    });
  }
  checkProgress() {
    if (this.applyInProgress) {
      if (this.movedAudits.length === this.movedAuditsProcessed
        && this.newAudits.length === this.newAuditsProcessed
        && this.deletedAudits.length === this.deletedAuditsProcessed
        && this.cancelledAudits.length === this.cancelledAuditsProcessed) {

          this.acceptWaitPanel.hide();
          this.applyInProgress = false;
          this.newAuditsProcessed = 0;
          this.movedAuditsProcessed = 0;
          this.deletedAuditsProcessed = 0;
          this.cancelledAuditsProcessed = 0;
          this.newAudits = [];
          this.movedAudits = [];
          this.deletedAudits =  [];
          this.cancelledAudits = [];
          this.reload(1,null);
      } else {
        this.applyInProgress = true;
      }
    }
  }

  reload(pageNo, event) {
    if (this.applyInProgress === true) {
      return;
    }
    const _self = this;
    this.paging.pagingPage = pageNo;
    const metainfo = {
      dataFilter: {},
      dataSort: {},
      dataPaging: {pageNo: pageNo}
    };
    this.isLoading = true;
    metainfo.dataSort[this.dataSort.field] = this.dataSort.order;
    for (const k of Object.keys(this.searchFields)) {
      // metainfo.dataFilter[k] = {value: this.searchFields[k], operator: 'LIKE'};
      metainfo.dataFilter[k] = this.searchFields[k];
    }
    _self.excRest.get(_self.excRest.computeUrl('PlanningHQR_List', {AuditYear: _self.year, level: _self.level}), {MetaInfo: metainfo}).subscribe(ret => {
      _self.data = ret.data;
      _self.paging = ret.paging ;
      this.isLoading = false;
    });
  }

  ngOnInit() {
    this.initialLoad();
  }

  GetPaginator(length?, element?): string[] {
    let reRender = false;
    if (element) {
      if (element.offsetWidth > 1000) {
        length = 13;
      }
      if (element.offsetWidth < 1000) {
        length = 9;
      }
      if (element.offsetWidth < 500) {
        length = 7;
      }
      if (element.offsetWidth < 300) {
        length = 5;
      }
      if (element.offsetWidth < 200) {
        length = 3;
      }
      reRender = reRender || (element.offsetWidth > 0 && this.pagingOldOffset !== element.offsetWidth);
    }
    if (!this.paging) {
      return;
    }
    reRender = reRender || this.pagingAactualPage !== this.paging.pagingPage || this.paging !== this.pagingInstace;
    if (!reRender) {
      return this.paginator;
    }
    if (element) {
      this.pagingOldOffset = element.offsetWidth;
    }
    this.pagingInstace = this.paging;
    this.pagingAactualPage = this.paging.pagingPage;
    let paginatorItems: any[] = [];
    const maxLength: number = (!length) ? 9 : length;
    if (maxLength < 5) {
      paginatorItems.push({label: '<', value: this.paging.pagingPage === 1 ? 1 : this.paging.pagingPage - 1});
      paginatorItems.push({label: this.paging.pagingPage, value: this.paging.pagingPage});
      paginatorItems.push({
        label: '>',
        value: this.paging.pagingPage === this.paging.pagingTotalPages ? this.paging.pagingTotalPages : this.paging.pagingPage + 1
      });
      this.paginator = paginatorItems;
      return paginatorItems;
    }

    let minDots;
    let maxDots;
    const middleNumbers = [];
    for (let i: any = 2; i < this.paging.pagingTotalPages; i++) {

      if (this.paging.pagingPage <= (maxLength + 1) / 2 && i < this.paging.pagingPage) {
        middleNumbers.push({label: i, value: i});
      } else if ((this.paging.pagingPage <= maxLength - 4 && i > this.paging.pagingPage
        && i < (maxLength - 1)) || this.paging.pagingTotalPages === maxLength) {
        middleNumbers.push({label: i, value: i});
      } else if (this.paging.pagingPage > this.paging.pagingTotalPages - (maxLength + 1) / 2 && i > this.paging.pagingPage) {
        middleNumbers.push({label: i, value: i});
      } else if (this.paging.pagingPage > this.paging.pagingTotalPages - maxLength - 4
        && i < this.paging.pagingPage && i > this.paging.pagingTotalPages - (maxLength - 2)) {
        middleNumbers.push({label: i, value: i});
      } else if (this.paging.pagingPage - i >= ((maxLength - 3) / 2)) {
        minDots = {label: '...', value: (i - ((maxLength - 5) / 2) < 2) ? 2 : i - ((maxLength - 5) / 2)};
      } else if (this.paging.pagingPage - i <= -1 * ((maxLength - 3) / 2)) {
        maxDots = maxDots || {
          label: '...',
          value: (i + ((maxLength - 5) / 2)) > this.paging.pagingTotalPages - 1
            ? this.paging.pagingTotalPages - 1
            : i + ((maxLength - 5) / 2)
        };
      } else {
        if ((this.paging.pagingPage - i > ((maxLength - 3) / 2)) || (this.paging.pagingPage - i < ((maxLength - 3) / 2))) {
          middleNumbers.push({label: i, value: i});
        }
      }
    }

    if (this.paging.pagingTotalPages > 0) {
      paginatorItems.push({label: '1', value: 1});
    }
    if (minDots) {
      paginatorItems.push(minDots);
    }

    // if(middleNumbers.length < (maxLength - 3) )

    paginatorItems = paginatorItems.concat(middleNumbers);

    if (maxDots) {
      paginatorItems.push(maxDots);
    }

    if (this.paging.pagingTotalPages > 1) {
      paginatorItems.push({label: this.paging.pagingTotalPages, value: this.paging.pagingTotalPages});
    }
    this.paginator = paginatorItems;
    return paginatorItems;
  }
}
